import { render, staticRenderFns } from "./WhiteBoard.vue?vue&type=template&id=2b37771f&scoped=true"
import script from "./WhiteBoard.vue?vue&type=script&lang=js"
export * from "./WhiteBoard.vue?vue&type=script&lang=js"
import style0 from "./WhiteBoard.vue?vue&type=style&index=0&id=2b37771f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b37771f",
  null
  
)

export default component.exports